import * as featureFlags from './feature-flags'

const validProps = ['type', 'exact', 'path', 'props', 'routes']

/**
 * A proxy wrapper around the route objects that single-spa expects for route configuration,
 * but extending the activeWhen setter function to respect split features.
 *
 * This is done with a proxy because singl-spa-layout's `activeWhen` definition happens inside
 * the route creation and directly sets `activeWhen`, then references it internally to build
 * the default route's behavior to only render if no siblings are active. This required(?) a
 * slightly creative workaround here to intercept the assignment of the function to wrap it with
 * our own function on set.
 */
export class AppRoute {
  constructor(options = {}) {
    for (const propName of validProps) {
      if (propName in options) {
        this[propName] = options[propName]
      }
    }
  }

  get activeWhen() {
    return super.activeWhen
  }

  set activeWhen(cb) {
    super.activeWhen = location => {
      const meta = this.props?.__meta || {}
      const flags = featureFlags.getMap()

      // If we have splits and the feature flags are ready
      if (flags && Array.isArray(meta.splits)) {
        // Get the first active split name which is enabled in the feature map
        const activeSplit = meta.splits.find(split => flags.get(split))

        // If the index of this route's split isn't the same as the first matching split, return
        // false. Note this behavior is specifically intended to only match the first matching
        // split, making the splits in the config order dependent with the first matching split
        // winning. It's also covering the fallback route, which has a split of undefined, which
        // will match a failed find for activeSplit.
        if (activeSplit !== meta.split) {
          return false
        }
      }

      return cb(location)
    }
  }
}
